import { render, staticRenderFns } from "./org-info.vue?vue&type=template&id=68951db0&"
import script from "./org-info.vue?vue&type=script&lang=ts&"
export * from "./org-info.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "org-info.vue"
export default component.exports